import { useContext } from 'react';
import { TurmaSelecionadaContext } from './turma-selecionada.provider';
import { Hook } from './turma-selecionada.types';

export const useTurmaSelecionada: Hook = () => {
  return useContext(TurmaSelecionadaContext);
};
